<template>
    <span class="desc_wrap">
        <div class="desc_icon" @mouseenter = "showDescription" @mouseleave = "hideDescription">
			<svg-icon :icon-class="iconClass" :icon-name="icon" :icon-size="iconSize" icon-fill="#aabed2"></svg-icon>
        </div>
        <transition enter-active-class="animated slideInDown"
                leave-active-class="animated fadeOut" mode="out-in">
            <div v-show="showDesc" class="desc_text" :style="'width:' + width + 'px'"
                :class = "direction">
                {{text}}
            </div>
        </transition>
    </span>
</template>
<script>
import svgIcon from './svg-icon';
export default {
	components: {
		"svg-icon":svgIcon
	},
    props: {
        icon: {default:'icon-info'},
        text: {default:'Text description'},
        direction:{default:'right'},
        width:{default:190},
		iconSize:{default:'0 0 32 32'},
		iconClass:{default:'icon icon--inline x15'}
    },
    methods: {
        showDescription() {
            this.showDesc = true;
        },
        hideDescription() {
            this.showDesc = false;
        }
    },
    data() {
        return {
            showDesc: false
        }
    }

}
</script>
<style lang="less" scoped>
.desc {
    &_wrap {
        position: relative;
        display: flex;
    }
    &_text {
        font-family: Arimo;
        font-size: 10px;
        text-transform: uppercase;
        position: absolute;
        text-align: center;
        line-height: 1.3;
        background: #324258;
        padding: 5px;
        border-radius: 4px;
        width: 190px;
        display: block;
        z-index: 1;
        box-shadow: 0 0 10px rgba(0,0,0,0.5);
    }
    &_icon {
        cursor: pointer;
        color:#aabed2;
    }
}
.right {
    left: 20px;
}
.left {
    right: 20px;
}
</style>
